<template>
  <v-col cols="12">
    <v-row>
      <v-col cols="12">
        <h1>{{ $t("profile.referrer.title") }}</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card elevation="0" color="grey lighten-5">
          <v-col cols="12">
            <h2>{{ $t("profile.referrer.usersTitle") }}</h2>
          </v-col>
          <v-col cols="12">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      {{ $t("profile.referrer.usersEmail") }}
                    </th>
                    <th class="text-right">
                      {{ $t("profile.referrer.usersDate") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="user in users" :key="user.id">
                    <td class="text-left">{{ user.user_email }}</td>
                    <td class="text-right">
                      {{ moment(user.dt_create).format("DD/MM/YYYY HH:mm") }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-card>
      </v-col>
      <!-- <v-col cols="6">
        <v-card elevation="0" color="grey lighten-5">
          <v-col cols="12">
            <h2>{{ $t("profile.referrer.payment") }}</h2>
          </v-col>
          <v-col cols="12">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      {{ $t("profile.referrer.paymentDate") }}
                    </th>
                    <th class="text-right">
                      {{ $t("profile.referrer.paymentAmount") }}
                    </th>
                    <th class="text-right">
                      {{ $t("profile.referrer.paymentStatus") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(payment, i) in payments" :key="i">
                    <td class="text-left">{{ payment.date }}</td>
                    <td class="text-right">{{ payment.amount }}</td>
                    <td class="text-right">{{ payment.status }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-card>
      </v-col> -->
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card elevation="0" color="grey lighten-5">
          <v-col cols="8" class="mx-auto">
            <v-col>
              <h2 class="text-center">
                {{ $t("profile.referrer.inviteText") }}
              </h2>
            </v-col>
            <v-col>
              <v-text-field
                ref="emailInput"
                filled
                dense
                v-model="email"
                :rules="[
                  (v) =>
                    /.+@.+\..+/.test(v) || $t('profile.referrer.emailInvalid'),
                ]"
                @input="verifyEmail"
                :label="$t('profile.referrer.mailLabel')"
              >
                <v-btn
                  :disabled="isEmailValid"
                  slot="append"
                  class="mb-3"
                  elevation="0"
                  color="primary"
                  @click="sendInvite()"
                  :loading="loading"
                  >{{ $t("profile.referrer.mailBtn") }}</v-btn
                >
              </v-text-field>
              <hr />
              <v-col class="pa-0 ma-0" style="position: relative">
                <v-text-field
                  ref="mylink"
                  class="mt-6"
                  filled
                  dense
                  v-model="link"
                  disabled
                  :label="$t('profile.referrer.copyLabel')"
                >
                </v-text-field>
                <v-btn
                  elevation="0"
                  style="position: absolute; top: 8px; right: 8px"
                  @click="copyURL"
                  color="primary"
                  >{{ $t("profile.referrer.copyBtn") }}</v-btn
                >
              </v-col>
            </v-col>
          </v-col>
        </v-card>
      </v-col>
      <v-col>
        <v-card color="grey lighten-5" elevation="0">
          <v-card-text>
            <v-col cols="12" class="text-center">
              <h2>
                {{ $t("profile.referrer.moreInfos") }}
              </h2>
              <v-btn
                class="my-6"
                color="primary"
                elevation="0"
                @click="contactUs()"
                >{{ $t("profile.referrer.infosBtn") }}</v-btn
              >
            </v-col>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-snackbar v-model="copied" color="success">{{
      $t("profile.referrer.copySnackbar")
    }}</v-snackbar>
    <v-snackbar v-model="send" color="success">{{
      $t("profile.referrer.sendSnackbar")
    }}</v-snackbar>
  </v-col>
</template>

<script>
import { mapState } from "vuex";
import api from "@/api";
import moment from "moment";

export default {
  computed: {
    ...mapState(["user"]),
  },

  data() {
    return {
      link: `https://my.previmeteo.com/inscription?referrer=22026`,
      copied: false,
      send: false,
      email: null,
      loading: false,
      isEmailValid: true,
      moment: moment,
      users: [],
      // payments: [
      //   {
      //     date: "1900-01-01",
      //     amount: 50,
      //     status: "payed",
      //   },
      //   {
      //     date: "1900-01-01",
      //     amount: 50,
      //     status: "waiting",
      //   },
      //   {
      //     date: "1900-01-01",
      //     amount: 50,
      //     status: "canceled",
      //   },
      // ],
    };
  },

  methods: {
    copyURL() {
      navigator.clipboard.writeText(this.link);
      this.copied = true;
    },
    async sendInvite() {
      this.loading = true;
      try {
        await api.referrer.invite({
          ...this.user,
          invite_user: this.email,
        });
        this.send = true;
      } catch (err) {
        console.log(err);
      }
      this.loading = false;
    },
    contactUs() {
      window.$crisp.do("chat:open");
    },
    async getReferrers() {
      try {
        let referrers = await api.referrer.get(this.user.id_user);

        this.users = referrers;
      } catch (err) {
        console.error(err.message);
      }
    },
    verifyEmail() {
      this.$refs.emailInput.valid ? (this.isEmailValid = false) : null;
    },
  },

  mounted() {
    this.getReferrers();
  },
};
</script>

<style>
</style>